import escapeXml from './escapeXml';

const buildXmlElement = (
  elementName: string,
  value: string,
  indent: string
): string =>
  value === ''
    ? `${indent}<${elementName}/>`
    : `${indent}<${elementName}>${escapeXml(value)}</${elementName}>`;

export default buildXmlElement;
